import { pipe } from "ramda";
import { watch } from "vue";

import { redirectWithTracking } from "@solvari/argus/thin-client";
import { extendUrlParams } from "@solvari/utils";

import { getAbTestFeature, getSentryAbTesting } from "@/client";
import { getBrowserAttributes } from "@/service/attributes";

function splitUrlFeature(redirect = redirectWithTracking) {
  const splitUrl = getAbTestFeature<string>("split-url");
  const { url } = getBrowserAttributes();

  watch(
    splitUrl,
    async (splitUrl) => {
      if (!splitUrl || splitUrl === url.value) {
        return;
      }

      await globalThis.abTesting!.fireDeferredTrackingCalls();
      pipe(extendUrlParams, redirect)(splitUrl);
    },
    { immediate: true },
  );
}

function splitUrlMapFeature(redirect = redirectWithTracking) {
  const splitUrlMap = getAbTestFeature<Record<string, string>>("split-url-map");
  const { url } = getBrowserAttributes();

  watch(
    splitUrlMap,
    async (splitUrlMap) => {
      if (!splitUrlMap) {
        return;
      }

      if (Object.values(splitUrlMap).includes(url.value)) {
        return;
      }

      const target = splitUrlMap[url.value];
      if (!target) {
        const error = new Error(
          `Tried to run split url test but the currentPage was not included in the test: ${url.value}`,
        );
        getSentryAbTesting().captureException(error);
        return;
      }

      await globalThis.abTesting!.fireDeferredTrackingCalls();

      pipe(extendUrlParams, redirect)(target);
    },
    { immediate: true, deep: true },
  );
}

export { splitUrlFeature, splitUrlMapFeature };
